console.log("log: process.env.NODE_ENV: ", process.env.NODE_ENV);

export const ENV = process.env.NODE_ENV || "development";

export const IS_DEV = ENV === "development";

export const IS_PROD = ENV === "production";
